import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { ArrowRight } from 'lucide-react';
export const WhatYouBuild = () => {
  const nodes = ['Community Issue', 'Root Cause', 'Stakeholders', 'AI Research', 'Solution Design', 'Pitch'];
  const examples = [{
    title: 'Youth Mental Health Access',
    desc: 'A peer-to-peer support network platform.'
  }, {
    title: 'Newcomer Settlement Tech',
    desc: 'Navigating local resources for new immigrants.'
  }, {
    title: 'Civic Engagement Platform',
    desc: 'Connecting youth to municipal policy decisions.'
  }, {
    title: 'Local Food Security',
    desc: 'Optimizing surplus food distribution logistics.'
  }];
  return <section className="py-24 md:py-32 bg-navy relative overflow-hidden" data-id="element-325">
      <div className="absolute inset-0 bg-noise pointer-events-none z-10" data-id="element-326" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-kesari/30 to-transparent" data-id="element-327" />

      <div className="max-w-7xl mx-auto px-6 relative z-20" data-id="element-328">
        <SectionHeader title="Real civic and social enterprise solutions." subtitle="You won't just talk about problems. You will map them, research them, and design scalable solutions." dark data-id="element-329" />

        {/* Animated Diagram */}
        <div className="my-20 py-12 border-y border-gold/10 relative" data-id="element-330">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-2" data-id="element-331">
            {nodes.map((node, idx) => <Fragment key={node} data-id="element-332">
                <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: idx * 0.15
            }} whileHover={{
              scale: 1.05,
              borderColor: 'var(--color-kesari)'
            }} className="relative z-10 bg-indigo border border-gold/30 px-6 py-4 rounded-sm text-center min-w-[160px] shadow-[0_0_15px_rgba(201,162,74,0.05)] hover:shadow-[0_0_20px_rgba(212,118,60,0.2)] transition-all cursor-default group" data-id="element-333">
                  <span className="font-sans text-sm font-medium text-ivory group-hover:text-kesari transition-colors" data-id="element-334">
                    {node}
                  </span>
                  {/* Active pulse effect on hover */}
                  <div className="absolute inset-0 border border-kesari rounded-sm opacity-0 group-hover:animate-ping" data-id="element-335" />
                </motion.div>

                {idx < nodes.length - 1 && <motion.div initial={{
              opacity: 0,
              width: 0
            }} whileInView={{
              opacity: 1,
              width: 'auto'
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: idx * 0.15 + 0.1
            }} className="text-gold/50 rotate-90 md:rotate-0" data-id="element-336">
                    <motion.div animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: idx * 0.2
              }} data-id="element-337">
                      <ArrowRight size={20} className="text-kesari/70" data-id="element-338" />
                    </motion.div>
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>

        {/* Example Projects */}
        <div data-id="element-339">
          <h4 className="font-sans text-sm text-gold uppercase tracking-wider mb-8 font-semibold flex items-center gap-3" data-id="element-340">
            <span className="w-8 h-px bg-gold/50" data-id="element-341" />
            Example Project Archetypes
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-342">
            {examples.map((ex, idx) => <motion.div key={ex.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} whileHover={{
            y: -5
          }} className="bg-indigo/30 border border-gold/10 p-6 rounded-sm hover:border-kesari/50 hover:bg-indigo/50 transition-all group" data-id="element-343">
                <h5 className="font-serif text-lg text-ivory mb-2 group-hover:text-kesari-soft transition-colors" data-id="element-344">
                  {ex.title}
                </h5>
                <p className="font-sans text-sm text-parchment/60" data-id="element-345">{ex.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};